module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_vestfold_telemark_neg.71406fd1.svg";